
import { defineComponent } from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import MarvinHappy from '@/components/svg/marvin/marvin_happy.svg?inline';
import X from '@/components/svg-components/X.vue';
import useUser from '@/mixins/useUser';

export default defineComponent({
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'InfoPopup_ProjectQuestions',
  components: { BCXMarkdown, MarvinHappy, X },
  emits: ['close'],
  setup(_, { emit }) {
    const { tUserFallback } = useUser('self');
    const close = () => emit('close');
    return { close, tUserFallback };
  }
});
